import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';

import { saveUpdateAnswer } from 'store/lesson-actions';

import classes from './InputQuestion.module.css';

const InputQuestion = props => {
  const { t } = useTranslation(['lesson']);
  const [value, setValue] = useState();
  const handleChange = event => {
    props.nextQuestion();
    setValue(event.target.value);
  };

  const sendAnswerHandler = () => {
    (async () => {
      await saveUpdateAnswer(
        props.idApplication,
        null,
        null,
        value,
        props.questionData.idQuestion
      );
    })();
  };

  return (
    <>
      <p className={classes.question}>{t('additional_comments')}</p>
      <p className={classes.questionStrong}>
        {t('enter_your_answer')}
      </p>
      <TextField
        label={t('writes')}
        multiline
        rows={4}
        value={value}
        onChange={handleChange}
        className={classes.inputAnswer}
        onBlur={sendAnswerHandler}
      />
    </>
  );
};

InputQuestion.propTypes = {
  // eslint-disable-next-line react/require-default-props
  nextQuestion: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  idApplication: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  currentQuestion: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  questionData: PropTypes.object
};

export default InputQuestion;
